import { BufferedEvent } from './types';

export const PRE_INIT_BUFFER_MAX_SIZE = 50;

const buffer: BufferedEvent[] = [];

/** Retém um evento observado antes de o cliente do SDK estar disponível. */
export function enqueueBufferedEvent(event: BufferedEvent): void {
  // Com a fila cheia, sai o mais antigo: descartar o novo perderia justamente o
  // evento com mais chance de explicar o estado atual da tela.
  if (buffer.length >= PRE_INIT_BUFFER_MAX_SIZE) {
    buffer.shift();
  }

  buffer.push(event);
}

/** Devolve os eventos retidos na ordem de recebimento e limpa a fila. */
export function drainBufferedEvents(): BufferedEvent[] {
  // A limpeza acontece antes de o chamador decidir se emite, para que um
  // carregamento concluído sem cliente descarte o lote em vez de retê-lo para sempre.
  return buffer.splice(0, buffer.length);
}

/** Descarta o estado de módulo entre testes. Não usar em código de produção. */
export function resetPreInitBufferForTests(): void {
  buffer.length = 0;
}
